import { Link, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { Button } from '@brent/core-ui/ui'
import { cn } from '@/lib/utils'

export function Layout() {
  const { user, logout } = useAuth()
  const location = useLocation()

  const navigation = [
    { name: 'Dashboard', href: '/dashboard' },
    { name: 'Suggestions', href: '/suggestions' },
  ]

  // Questions visible to question-viewer, question-editor, and administrator
  const questionGroups = ['administrator', 'question-editor', 'question-viewer']
  if (user?.groups.some((g) => questionGroups.includes(g))) {
    navigation.push({ name: 'Questions', href: '/questions' })
  }

  // Surveys visible to survey-viewer, survey-editor, and administrator
  const surveyGroups = ['administrator', 'survey-editor', 'survey-viewer']
  if (user?.groups.some((g) => surveyGroups.includes(g))) {
    navigation.push({ name: 'Surveys', href: '/surveys' })
  }

  if (user?.groups.includes('administrator')) {
    navigation.push({ name: 'Users', href: '/users' })
  }

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b">
        <div className="container mx-auto flex h-16 items-center justify-between px-4">
          <div className="flex items-center space-x-8">
            <Link
              to="/dashboard"
              className="flex items-center gap-3 hover:opacity-80 transition-opacity"
            >
              <img
                src="/images/BSO%20Logo%20Black.svg"
                alt="BSO Logo"
                className="h-10 dark:invert"
              />
              <span className="text-lg font-bold">Admin Portal</span>
            </Link>
            <nav className="flex space-x-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={cn(
                    'text-sm font-medium transition-colors hover:text-primary',
                    location.pathname === item.href ? 'text-foreground' : 'text-muted-foreground',
                  )}
                >
                  {item.name}
                </Link>
              ))}
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            <span className="text-sm text-muted-foreground">{user?.email}</span>
            <Button variant="outline" size="sm" onClick={logout}>
              Sign out
            </Button>
          </div>
        </div>
      </header>
      <main className="container mx-auto px-4 py-8">
        <Outlet />
      </main>
    </div>
  )
}
